import { NgModule } from '@angular/core';
import { CardWidgetComponent } from './card-widget.component';
import { CommonModule } from '@angular/common';
import { UwButtonComponent } from './buttons/uw-button/uw-button.component';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [CardWidgetComponent, UwButtonComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [CardWidgetComponent, UwButtonComponent]
})
export class CardWidgetModule { }
